import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useAddNoteMutation } from "../api/apiSlice";

export default function Notes() {
  const meetingId = useSelector((state) => state.meeting.meetingId);
  const [notes, setNotes] = useState("");
  const [addNote, { isLoading, isSuccess, isError, reset }] = useAddNoteMutation();

  const handleSave = async () => {
    if (!notes.trim()) return;

    try {
      await addNote({
        meetingId,
        note: notes.trim(),
        time: new Date().toISOString(),
      }).unwrap();

      setNotes(""); // Clear the input after successful save
    } catch (err) {
      console.error("Failed to save note:", err);
    }
  };

  // Clear success toast after 3 seconds
  useEffect(() => {
    if (isSuccess) {
      const timer = setTimeout(() => {
        reset();
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isSuccess, reset]);

  return (
    <section className="widget-card">
      <h3 className="widget-title">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
          <path d="M18.5 2.5a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4z" />
        </svg>
        Meeting Notes
      </h3>

      <div className="notes-container">
        <textarea
          rows={5}
          value={notes}
          placeholder="Type important items, action items, or remarks here..."
          onChange={(e) => setNotes(e.target.value)}
          className="notes-textarea"
        />

        <div className="notes-footer">
          <span className="notes-char-count">
            {notes.length} characters
          </span>

          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            {isSuccess && (
              <span className="feedback-msg success">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                Note saved!
              </span>
            )}
            {isError && (
              <span className="feedback-msg error">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                >
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="12" />
                  <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
                Failed to save.
              </span>
            )}

            <button
              onClick={handleSave}
              disabled={isLoading || !notes.trim()}
              className="btn btn-success"
            >
              {isLoading ? (
                <>Saving...</>
              ) : (
                <>
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
                    <polyline points="17 21 17 13 7 13 7 21" />
                    <polyline points="7 3 7 8 15 8" />
                  </svg>
                  Save Notes
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
